exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ck-placeholder:before{content:attr(data-placeholder);cursor:text;color:#c2c2c2;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/css-loader?{"minimize":true}!/workspace/ckeditor5/node_modules/sass-loader/lib/loader.js!../ckeditor5-engine/theme/placeholder.scss
// module id = 535
// module chunks = 0